import makeInspectable from 'mobx-devtools-mst';
import { onSnapshot } from 'mobx-state-tree';
import { createBrowserHistory } from 'history';

import { Api, DigitalOrdersApi, ConfigApi, AutomationApi } from '../api';
import { MobxEnvironment } from './mobx-environment';
import { load, save } from '../libs/storage';
import { RootStoreModel } from '../core/stores/RootStore';
import { RootStore } from '../core/stores/store.types';
import { ROOT_STATE_STORAGE_KEY } from './mobx-constants';
import { syncHistoryWithStore } from './stores';

export type GetRootStore = () => RootStore;

/**
 * Setup the root state.
 */
export function setupRootStore(): { rootStore: RootStore; history: any } {
  let rootStore: RootStore;

  const mobxEnvironment = createMobxEnvironment();

  try {
    let initialState = {};
    const stateFromStorage = load(ROOT_STATE_STORAGE_KEY);
    if (RootStoreModel.is(stateFromStorage)) {
      initialState = stateFromStorage;
    }
    rootStore = RootStoreModel.create(initialState, mobxEnvironment);
  } catch (error) {
    console.error(error);
    rootStore = RootStoreModel.create({}, mobxEnvironment);
  }

  makeInspectable(rootStore);

  onSnapshot(rootStore, snapshot => save(ROOT_STATE_STORAGE_KEY, snapshot));

  const history = syncHistoryWithStore(createBrowserHistory(), rootStore.navigationStore);

  return { rootStore, history };
}

function createMobxEnvironment() {
  const mobxEnvironment = new MobxEnvironment();

  mobxEnvironment.api = new Api();
  mobxEnvironment.digitalOrdersApi = new DigitalOrdersApi();
  mobxEnvironment.configApi = new ConfigApi();
  mobxEnvironment.automationApi = new AutomationApi();

  try {
    mobxEnvironment.api.setup();
  } catch (error) {
    console.error(error);
  }

  return mobxEnvironment;
}
